import { Injectable } from '@angular/core';
import {Subject} from "rxjs";
import {UtilsService} from "./utils.service";
import {HttpHeaders, HttpClient} from "@angular/common/http";


@Injectable()
export class WishListService {


  wishList: any;
  constructor(
    private utilsService: UtilsService,
    private httpClient: HttpClient
  ) {
    this.wishList = JSON.parse(localStorage.getItem('wishList'));

  }

  public list(){
    return this.wishList;
  }

  public toggleItem(type, itemId){

    let that = this;
    if(that.wishList === null){
      let items = {};
      items[type] = [itemId];
      that.wishList = items;
      localStorage.setItem('wishList', JSON.stringify(that.wishList));
    }else{
      if(!that.wishList.items){
        that.wishList = {
          items: {}
        }
      }
      let items = that.wishList.items[type];
      if(!items){
        that.wishList.items[type] = items = [];
      }
      if(items.indexOf(itemId)>-1){
        that.wishList.items[type].splice(items.indexOf(itemId),1);
      }else{
        that.wishList.items[type].push(itemId);
      }
      localStorage.setItem('wishList', JSON.stringify(that.wishList));
    }
    that.utilsService.newWishEvent('update');
    return that.wishList;
  }


  public getAll(){
    let httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    return this.httpClient.post(this.utilsService.apiEndpoint+'wishlist', this.wishList, {
      responseType: 'json',
      headers: httpHeaders
    });
  }


}



// WEBPACK FOOTER //
// /Users/ugyen/Documents/Bhutan-office/my_bhutan/mybhutan-travel/src-admin/app/services/wish-list.service.ts